import { uiComponents, uiStates } from '@/tools/viewState';
import { mutationTypes } from '@/types';

export default {
	init() {
		[...this.$el.querySelectorAll('.mapButton')].forEach(() => {
			this.$store.commit(mutationTypes.viewStateSetUiState, {
				id: uiComponents.uiMap,
				uiState: uiStates.maximised,
			});
		});
	},
};
